
      import { Buffer as B } from 'buffer';
      if (typeof globalThis.Buffer === 'undefined') globalThis.Buffer = B;
      if (typeof globalThis.global === 'undefined') globalThis.global = globalThis;
      if (typeof globalThis.process === 'undefined') {
        globalThis.process = { env: {} };
      } else if (!globalThis.process.env) {
        globalThis.process.env = {};
      }
    